import axios from './index';

let baseURL = window.location.origin;

if (process.env.PROXY_SERVER_URL) {
  baseURL = process.env.PROXY_SERVER_URL;
}

function setAxiosDefaultBaseURL(currentUser) {
	const teamNameSpace = currentUser.team.namespace;
	axios.defaults.baseURL = `${baseURL}/api/v1/teams/${teamNameSpace}`;
}

function configAuthAxios(teamName) {
	axios.defaults.withCredentials = true;
	axios.defaults.headers.common = { 'X-ByteArk-Team': teamName };
	axios.defaults.baseURL = `${baseURL}/api/v1`;
}

export {
	setAxiosDefaultBaseURL,
	configAuthAxios,
};



// WEBPACK FOOTER //
// ./src/modules/axios/config.js